import { z } from 'zod';
export const CategoryPermissionTabKey = {
  ALL: 'ALL'
} as const;
export type CategoryPermissionTabKey = (typeof CategoryPermissionTabKey)[keyof typeof CategoryPermissionTabKey];
export const SearchSchema = z.object({
  category: z.enum([CategoryPermissionTabKey.ALL]).default(CategoryPermissionTabKey.ALL),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;